import {IFieldsInfo} from '../interfaces/reducers'
import {IFeatureLayerInfo, IImageLegendRowInfo, IViewSchema} from '../interfaces/models'
import {ISourceDescription} from '../interfaces/models'
import {GeometryType} from '../enums/GeometryType'
import {ViewSchemaType} from '../enums/ViewSchemaType'
import {VectorLayer, TileLayer, ImageLayer, Base} from './ol/Layers'

export class FeatureLayerInfo implements IFeatureLayerInfo {
  public fields: IFieldsInfo
  public url: Readonly<string>
  public sourceDescription: ISourceDescription

  public viewSchema: IViewSchema

  public imageLayer: ImageLayer | TileLayer
  public vectorLayer: VectorLayer

  public imageLegendRows: IImageLegendRowInfo[] = []

  constructor(fields: IFieldsInfo, sourceDescription: ISourceDescription) {
    this.viewSchema = {}
    for (let i = 0; i < 30; i++) {
      if (sourceDescription.pseudoViewSchema[i]) {
        this.viewSchema[i] = sourceDescription.pseudoViewSchema[i]
      } else {
        if (this.viewSchema[i - 1]) {
          this.viewSchema[i] = this.viewSchema[i - 1]
        } else {
          this.viewSchema[i] = ViewSchemaType.None
        }
      }
    }
    this.fields = fields
    this.sourceDescription = sourceDescription
    //TODO remove this prop - url
    this.url = sourceDescription.id
  }

  public hasVectorViewSchema(): boolean {
    let result = false
    for (const key in this.viewSchema) {
      if (this.viewSchema[key] == ViewSchemaType.Vector) {
        result = true
        break
      }
    }
    return result
  }

  public hasImageViewSchema(): boolean {
    let result = false
    for (const key in this.viewSchema) {
      if (this.viewSchema[key] == ViewSchemaType.Image || this.viewSchema[key] == ViewSchemaType.TileImage) {
        result = true
        break
      }
    }
    return result
  }

  public refresh(): void {
    if (this.imageLayer) {
      this.imageLayer.refresh()
    }
    if (this.vectorLayer) {
      this.vectorLayer.refresh()
    }
  }

  public getLayer(zoom: number): Base | undefined {
    const layerType = this.viewSchema[parseInt(zoom.toFixed(0))]
    if (layerType == ViewSchemaType.Image || layerType == ViewSchemaType.TileImage) {
      return this.imageLayer
    } else if (layerType == ViewSchemaType.Vector) {
      return this.vectorLayer
    }
    return undefined
  }

  public getImageLegendRowInfos(zoom: number): IImageLegendRowInfo[] {
    const result: IImageLegendRowInfo[] = []

    return result
  }
  public getGeometryType(): GeometryType {
    for (const field in this.fields) {
      if (this.fields[field].type == 'geometry') {
        return this.fields[field].geometryType
      }
    }
    return GeometryType.None
  }
  clone(): IFeatureLayerInfo {
    const clone = new FeatureLayerInfo(this.fields, this.sourceDescription)
    clone.imageLegendRows = this.imageLegendRows

    clone.vectorLayer = this.vectorLayer
    clone.imageLayer = this.imageLayer
    return clone
  }
}
